import React from "react";
import { Link } from "react-router-dom";
import { MapPin, BedDouble, Users } from "lucide-react";

export default function PropertyCard({ property, index = 0 }) {
  const img = property.images?.[0] || "";
  return (
    <Link
      to={`/properties/${property.id}`}
      data-testid={`property-card-${property.id}`}
      className="group block reveal is-visible"
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="relative overflow-hidden bg-[#1C1C1E] border border-[#F5F5DC]/10 group-hover:border-[#D4AF37]/40 transition-all duration-500">
        <div className="aspect-[4/5] overflow-hidden">
          <img
            src={img}
            alt={property.name}
            className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
            loading="lazy"
          />
        </div>
        <div className="absolute top-4 left-4 flex items-center gap-2">
          {property.featured && (
            <span className="text-[10px] tracking-[0.24em] uppercase px-3 py-1 bg-[#D4AF37] text-[#121212]">
              Featured
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <p className="overline text-[#D4AF37]">{property.location}</p>
          <h3 className="font-serif-luxe text-3xl mt-2 text-[#F5F5DC] leading-none">
            {property.name}
          </h3>
          <p className="mt-2 text-sm text-[#F5F5DC]/70 line-clamp-1">
            {property.tagline}
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between text-xs text-[#A3A3A3]">
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1.5">
            <BedDouble size={14} /> {property.bedrooms} BR
          </span>
          <span className="flex items-center gap-1.5">
            <Users size={14} /> Sleeps {property.max_guests}
          </span>
        </div>
        <div className="text-[#F5F5DC]">
          <span className="font-serif-luxe text-2xl text-[#D4AF37]">
            ${property.price_per_night?.toLocaleString?.() || property.price_per_night}
          </span>
          <span className="text-xs text-[#737373]"> / night</span>
        </div>
      </div>
    </Link>
  );
}
